import axios from "axios";
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const visitorFormService = {
  getList,
  getVisitorForm,
  createVisitorForm,
  createVisitorFormWithInduction,
  getEmbeddedInduction,
  getSurveyQuestion,
  getVisitorFormByProperty,
  uploadImage,
  uploadFile
};

function getList(formId, params={}){
  return (
    axios
      .get(
        `${apiEndpoint.visitorForm}?form_id=${formId}`,
        {
          headers: authHeader(),
          params: params
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function getVisitorForm(token){
  return (
    axios
      .get(
        `${apiEndpoint.visitorForm}/get-visitor-form?token=${token}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}

function getVisitorFormByProperty(property_id, params= {}){
  return (
    axios
      .get(
        `${apiEndpoint.visitorForm}/get-visitor-form-by-property?property_id=${property_id}`,
        {
          params,
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}


// What this check-in owes before it is submitted: an induction to render, or
// nothing. Public, like the rest of the check-in path — gated by the form token.
function getEmbeddedInduction(formToken, email, phone){
  return (
    axios
    .get(`${apiEndpoint.visitorForm}/embedded-induction`, {
      params: { visitor_form_token: formToken, email: email || undefined, phone: phone || undefined },
    }).then(res => (res && res.data) ? res.data : { code: 'error' })
    .catch(() => ({ code: 'error' }))
  );
}

// Required mode only: the check-in and the induction commit together, so an
// abandoned induction leaves no check-in behind it.
function createVisitorFormWithInduction(data){
  return (
    axios
    .post(
      `${apiEndpoint.visitorForm}/create-with-induction`,
      data
    ).then(res => {
        if(res && res.data){
          return res.data;
        }
        return { code: 'error', message: 'Submission failed. Please try again.' };
      })
  );
}

function createVisitorForm(data){
  return (
    axios
    .post(
      `${apiEndpoint.visitorForm}/create-visitor-form`,
      data
    ).then(res => {
        // Return the payload whatever the code is — callers branch on
        // res.code/res.message to surface backend validation errors.
        if(res && res.data){
          return res.data;
        }
        return { code: 'error', message: 'Submission failed. Please try again.' };
      })
  );
}

function uploadImage(data){
  return (
    axios
    .post(
      `${apiEndpoint.visitorForm}/upload-image`,
      data
    ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function uploadFile(data){
  return (
    axios
    .post(
      `${apiEndpoint.visitorForm}/upload-file`,
      data
    ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function getSurveyQuestion(visitorFormToken){
  return (
    axios
      .get(
        `${apiEndpoint.visitorForm}/get-survey-question?visitor_form_token=${visitorFormToken}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.data){
          return res.data;
        }
        return { code: 'error', message: 'Unable to load survey questions.' };
      })
  );
}